import React from 'react';

const OrderDetailsTabs = ({
	type,
	currentStep,
	isDrafted,
	orderPlaceMentStatus,
	orderCancelInfo,
	onChangeStep
}) => {
	const orderPlacementStatusList =
		type === 'PENDING'
			? orderPlaceMentStatus.filter(
					(item) => !['COMMERCIAL_INVOICE', 'PAYMENT_TRACKER'].includes(item.workflowStep)
				)
			: orderPlaceMentStatus
					.filter((item) => !['TEAM'].includes(item.workflowStep))
					.filter((item) => {
						if (orderCancelInfo.status === 'APPROVED') {
							return ['ORDER_INFO'].includes(item.workflowStep);
						} else {
							return true;
						}
					});
	return (
		<>
			{!isDrafted && (
				<div className="order-details-sidebar orderer-details-pending-sidebar">
					<ul className="d-flex flex-wrap">
						{orderPlacementStatusList?.map((item) => (
							<li
								key={item.workflowStep}
								className={`d-flex align-items-center align-self-center ${currentStep === item.stepName ? 'selected' : ''}`}
								onClick={() => onChangeStep(item)}
							>
								{item.stepName}
							</li>
						))}
					</ul>
				</div>
			)}
		</>
	);
};

export default OrderDetailsTabs;
